
import {
  defineComponent,
  useContext,
  computed,
  watch,
  useFetch,
  useRoute,
} from '@nuxtjs/composition-api';
import { reactiveComputed } from '@vueuse/core';
import { useFetchPage, useFetchBrands } from '@webplatform/nuxt-cms-js-sdk';
import PageBlocks from '@/components/PageBlocks.vue';
import CatalogLayout from '@/domains/catalog/components/CatalogLayout.vue';
import CatalogFilter from '@/domains/catalog/components/CatalogFilter.vue';
import { BrandCard } from '@/domains/brand';
import { useFilter } from '~/composables';
import { prepareBreadcrumbs } from '~/helpers';

export default defineComponent({
  components: {
    PageBlocks,
    CatalogLayout,
    CatalogFilter,
    BrandCard,
  },
  setup() {
    const { i18n } = useContext();
    const route = useRoute();
    const currentPage = computed(() => route.value.query.page);
    const { page, fetchPage } = useFetchPage('vendors', {
      lang: i18n.locale,
    });

    const { selectedFilters, getFiltersFromURL, handleFilterChanged } =
      useFilter();
    const sorting = { 'sort[name]': 'asc' };

    const params = reactiveComputed(() => ({
      ...selectedFilters.value,
      ...sorting,
      page: currentPage.value,
      lang: i18n.locale,
    }));

    const { brands, fetchBrands, meta } = useFetchBrands(params);
    const brandsCategories = computed(() => brands.value?.categories);
    const brandsTags = computed(() => brands.value?.tags);
    const brandAggs = computed(() => {
      return [
        {
          id: 'tag_id',
          name: i18n.tc('category', 1),
          buckets: brandsTags.value,
        },
      ];
    });

    const totalPagesCount = computed(() => meta.value?.last_page);

    useFetch(async () => {
      await fetchPage();
      await fetchBrands();
    });

    watch(
      () => route.value.query,
      async () => {
        getFiltersFromURL();
        await fetchBrands();
      },
    );

    const breadcrumbs = computed(() => [
      ...(page.value?.breadcrumbs || []).map(prepareBreadcrumbs),
      {
        text: i18n.tc('vendor', 2),
      },
    ]);

    return {
      page,
      breadcrumbs,
      brands,
      brandsCategories,
      brandAggs,
      totalPagesCount,
      selectedFilters,
      handleFilterChanged,
    };
  },
  head: {},
});
